export const indexPageEmpresa = "/configuracoes/empresa";
export const indexPageGruposDadosPagamento = "/configuracoes/dados-de-pagamento";

export const menuOptions = [
	{
		id: "empresa",
		path: "/configuracoes/empresa",
		icon: null,
		label: "Dados da empresa",
		subMenu: null,
	},
	{
		id: "dados-de-pagamento",
		path: "/configuracoes/dados-de-pagamento",
		icon: null,
		label: "Dados de Pagamento",
		subMenu: null,
	},
	{
		id: "termos-de-uso",
		path: "/configuracoes/termos-de-uso",
		icon: null,
		label: "Termos de Uso",
		subMenu: null,
	},
];
